import { MenuItem } from "@mui/material";
import { saveAs } from "file-saver";
import {
  gridFilteredSortedRowIdsSelector,
  gridVisibleColumnFieldsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import * as React from "react";
//import dayjs from "dayjs";

const ExcelJS = require("exceljs");

// Get data on grid
const getExcelData = (apiRef) => {
  // Select rows and columns
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

  // Format the data. Here we only keep the value
  const data = filteredSortedRowIds.map((id) => {
    const row = {};
    visibleColumnsField.forEach((field) => {
      row[field] = apiRef.current.getCellParams(id, field).value;
    });
    return row;
  });

  return data;
};

//Init header columns
const initHeaderColumns = (headers) => {
  let headerColumns = [];
  headers.forEach((h) => {
    let headerColumn = { key: h, width: 10 };
    headerColumns.push(headerColumn);
  });
  return headerColumns;
};

const Baocaogiayvantaiexcel = function Baocaogiayvantaiexcel() {
  const apiRef = useGridApiContext();
  const data = getExcelData(apiRef);
  // Auto Width
  const autoWidth = (worksheet, minimalWidth) => {
    worksheet.columns.forEach((column) => {
      let maxColumnLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        maxColumnLength = Math.max(
          maxColumnLength,
          minimalWidth,
          cell.value ? cell.value.toString().length : 0
        );
      });
      column.width = maxColumnLength + 2;
    });
  };

  const handleExport = async () => {
    // Init workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("My Sheet");

    // Title
    sheet.mergeCells(1, 1, 1, Object.keys(data[0]).length);
    sheet.getCell("A1").value = "BÁO CÁO THÁNG XE TUYẾN CỐ ĐỊNH";

    // Init header columns at row 2 on excel file
    var headerValues = [];
    for (const element of Object.keys(data[0])) {
      if (element == "ngaygiayvantai") {
        headerValues.push("Ngày giấy vận tải");
      } else if (element == "bienkiemsoat") {
        headerValues.push("Biển kiểm soát");
      } else if (element == "sogiayvantai") {
        headerValues.push("Số GVT");
      } else if (element == "ngayhethan") {
        headerValues.push("Ngày hết hạn");
      } else if (element == "sohopdong") {
        headerValues.push("Số hợp đồng");
      } else if (element == "ngayhopdong") {
        headerValues.push("Ngày hợp đồng");
      } else if (element == "tennguoithue") {
        headerValues.push("Người thuê");
      } else if (element == "diachinguoithue") {
        headerValues.push("Địa chỉ đơn vị thuê");
      } else if (element == "tuyenvanchuyen") {
        headerValues.push("Tuyến vận chuyển");
      } else if (element == "diemxephang") {
        headerValues.push("Điểm xếp hàng");
      } else if (element == "tg_xephang") {
        headerValues.push("Thời gian xếp hàng");
      } else if (element == "diemgiaohang") {
        headerValues.push("Điểm giao hàng");
      } else if (element == "tg_giaohang") {
        headerValues.push("Thời gian giao hàng");
      } else if (element == "quangduong") {
        headerValues.push("Quãng đường (km)");
      } else if (element == "tenhanghoa") {
        headerValues.push("Hàng hóa");
      } else if (element == "khoiluonghanghoa") {
        headerValues.push("Khối lượng (kg)");
      } else if (element == "hanghoathongtinkhac") {
        headerValues.push("Thông tin khác");
      } else if (element == "ngaycn") {
        headerValues.push("Ngày cập nhật");
      } else if (element == "nguoicn") {
        headerValues.push("Người cập nhật");
      }
    }

    sheet.getRow(2).values = headerValues;
    sheet.columns = initHeaderColumns(Object.keys(data[0]));

    // Fullfill data for excel file
    sheet.addRows(data);

    // Design excel
    // Auto column width for excel file with default 10px
    autoWidth(sheet, 10);

    // Design Border and Common Alignment + Font
    sheet.eachRow(function (row) {
      row.eachCell({ includeEmpty: true }, function (cell) {
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "left",
          wrapText: true,
        };
        cell.font = {
          name: "Times New Roman",
          size: 13,
        };
      });
    });

    // Design Title
    sheet.getCell("A1").font = {
      bold: true,
      name: "Times New Roman",
      size: 13,
    };
    sheet.getCell("A1").alignment = {
      vertical: "middle",
      horizontal: "center",
    };

    // Design header
    const row2 = sheet.getRow(2);
    row2.eachCell(function (cell) {
      if (cell.value) {
        cell.font = {
          bold: true,
          name: "Times New Roman",
          size: 13,
        };
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
        };
      }
    });
    if (Object.keys(data[0]).includes("ngaygiayvantai")) {
      const colngaygiayvantai = sheet.getColumn("ngaygiayvantai");
      colngaygiayvantai.eachCell(function (cell, rowNumber) {
        if (rowNumber > 2) {
          cell.numFmt = "dd.mm.yyyy";
        }
      });
    }
    if (Object.keys(data[0]).includes("ngayhethan")) {
      const colngayhethan = sheet.getColumn("ngayhethan");
      colngayhethan.eachCell(function (cell, rowNumber) {
        if (rowNumber > 2) {
          cell.numFmt = "dd.mm.yyyy";
        }
      });
    }
    if (Object.keys(data[0]).includes("ngayhopdong")) {
      const colngayhopdong = sheet.getColumn("ngayhopdong");
      colngayhopdong.eachCell(function (cell, rowNumber) {
        if (rowNumber > 2) {
          cell.numFmt = "dd.mm.yyyy";
        }
      });
    }
    // Design special Columns
    if (Object.keys(data[0]).includes("ngaycn")) {
      const colngaycn = sheet.getColumn("ngaycn");
      colngaycn.eachCell(function (cell, rowNumber) {
        if (rowNumber > 2) {
          cell.numFmt = "dd.mm.yyyy";
        }
      });
    }

    // Write excel file
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs.saveAs(new Blob([buffer]), "Baocaogiayvantaiexcel.xlsx");
  };

  return (
    <MenuItem
      onClick={() => {
        if (data[0]) {
          handleExport();
        }
      }}
    >
      Download Excel
    </MenuItem>
  );
};

export default Baocaogiayvantaiexcel;
